import { Turbo } from "@hotwired/turbo-rails";
import "packs/engines/subscriber_v2/controllers";
import "trix";
import ujs from "@rails/ujs";
import "utils/frame_missing_handler";
import { logEvent, setUserProperties, identify, startSessionRecording } from "utils/analytics";
import { showToast } from "utils/toast";
import PlaybackDb, { installNativePlaybackBridge } from "./playback_database";
import * as queueClient from "./queue_client";
import "./service_worker_registration";

ujs.start();

if (document.cookie.indexOf('sc_debug') !== -1) {
  startSessionRecording();
}

window.playbackDb = new PlaybackDb();
installNativePlaybackBridge(window.playbackDb);
window.queueClient = queueClient;
// Minted once per page load and sent as X-Queue-Client-Id so this device can ignore the
// broadcast its own change triggers. Falls back when crypto.randomUUID is unavailable
window.queueClientId =
  window.crypto && typeof window.crypto.randomUUID === "function"
    ? window.crypto.randomUUID()
    : `qc-${Date.now()}-${Math.random().toString(36).slice(2)}`;
window.Turbo = Turbo;
window.analytics = { logEvent, setUserProperties, identify };
window.showToast = showToast;
